import React from 'react'
import { UserDashboard } from './UserDashboard'

const MainDashboard = () => {
    return (
        <UserDashboard />
    )
}

export default MainDashboard